import React, { useState } from "react";
import FileTag from "./FileTag";
import { AiOutlineMinus } from "react-icons/ai";
const MultiInputTagImage = ({
  label,
  length,
  name,
  defaultImage,
  defaultValue,
  type,
  required,
  handleRemoveElement,
  id,
}) => {
  const [visibility, setVisibility] = useState(true);
  const handleDelete = (event) => {
    // setVisibility(false);
    // SEND the label to filter out and delete
    handleRemoveElement(id);
  };

  return (
    <div
      key={Math.random()}
      className={visibility ? "" : "gap-1 items-end hidden"}
    >
      <div className="flex  gap-2">
        <label className="input-group flex-col">
          <label className="label">
            <span className="text-md font-semibold p-0">
              {/* {length ? label + " " + length : label} */}
              {label}
            </span>
          </label>

          <FileTag
            label={label}
            length={length}
            name={visibility ? name : ""}
            defaultValue={defaultImage}
            type={type}
            required={required}
          />
          <input
            name={visibility ? name : ""}
            defaultValue={defaultValue}
            type={type}
            className="py-3 px-4 border border-gray-900 wew mt-2.5 outline-none"
            required={required}
          />
        </label>
        <div className="pt-10">
          <button
            type="button"
            onClick={handleDelete}
            className="btn  btn-sm h-[100%]"
          >
            <AiOutlineMinus />
          </button>
        </div>
      </div>
    </div>
  );
};

export default MultiInputTagImage;
